import React from 'react';
import Link from 'next/link';
import { useTheme } from 'styled-components';
import { Dropdown, Typography } from '@/components/atoms';
import { NavigationProps } from './Navigation.types';
import { Nav, Items, DropdownSelector, DropdownItem, DropdownContainer } from './Navigation.styles';
import * as FeatherIcon from 'react-feather';
import { useTranslation } from 'next-i18next';

const Navigation: React.FC<NavigationProps> = ({ id, type, title, menuItems, activeItem, handleToggleSidebar }) => {
    const theme = useTheme();
    const { t } = useTranslation(); // Translations

    return (
        <Nav id={id} type={type}>
            {type !== 'main' && title && (
                <Typography as="h3" variant="sub1" color={theme.colors.tertiary.tertiary50}>
                    {title}
                </Typography>
            )}
            <Items orientation={type === 'main' ? 'row' : 'column'} type={type}>
                {menuItems.map((item) => {
                    if (item.isDropdown) {
                        if (type !== 'footer') {
                            return (
                                <li key={item.key}>
                                    <Dropdown
                                        id={id}
                                        triggerLabel={t('common:language-switcher.label')}
                                        trigger={
                                            <DropdownSelector>
                                                <Typography
                                                    as="span"
                                                    variant="sub2"
                                                    mr={5}
                                                    color={activeItem === item.key ? theme.colors.secondary.secondary50 : theme.colors.tertiary.tertiary50}
                                                >
                                                    {item.text}
                                                </Typography>
                                                <FeatherIcon.ChevronDown size={20} color={theme.colors.tertiary.tertiary50} />
                                            </DropdownSelector>
                                        }
                                    >
                                        <DropdownContainer>
                                            {item.items?.map((subItem) => {
                                                return (
                                                    <DropdownItem key={subItem.key}>
                                                        <Link href={subItem.href} passHref>
                                                            <Typography as="span" variant="sub2" ml={10}>
                                                                {subItem?.text}
                                                            </Typography>
                                                        </Link>
                                                    </DropdownItem>
                                                );
                                            })}
                                        </DropdownContainer>
                                    </Dropdown>
                                </li>
                            );
                        }
                        return null;
                    }
                    return (
                        <li key={item.key}>
                            <Link href={item.href} passHref>
                                <Typography
                                    as="span"
                                    variant={type === 'footer' ? 'body2' : 'sub2'}
                                    color={
                                        type === 'footer'
                                            ? theme.colors.neutral.neutral10
                                            : activeItem === item.key
                                            ? theme.colors.secondary.secondary50
                                            : theme.colors.tertiary.tertiary50
                                    }
                                    onClick={handleToggleSidebar}
                                    className={type !== 'footer' && activeItem === item.key ? 'active' : ''}
                                >
                                    {item.text}
                                </Typography>
                            </Link>
                        </li>
                    );
                })}
            </Items>
        </Nav>
    );
};

Navigation.defaultProps = {
    type: 'main',
};

export default Navigation;
